import { ReactElement } from "react";
import {
  Box,
  SimpleGrid,
  Icon,
  Text,
  Stack,
  Flex,
  useColorModeValue,
} from "@chakra-ui/react";
import { FcAssistant, FcDonate, FcInTransit } from "react-icons/fc";
import {
  IoAnalyticsSharp,
  IoLogoBitcoin,
  IoSearchSharp,
} from "react-icons/io5";

interface FeatureProps {
  title: string;
  text: string;
  icon: ReactElement;
  iconBg?: string;
}

const Feature = ({ title, text, icon, iconBg }: FeatureProps) => {
  return (
    <Stack>
      <Flex
        w={16}
        h={16}
        align={"center"}
        justify={"center"}
        color={"white"}
        rounded={"full"}
        bg={iconBg}
        mb={1}
      >
        {icon}
      </Flex>
      <Text fontWeight={600}>{title}</Text>
      <Text color={"gray.600"}>{text}</Text>
    </Stack>
  );
};

export default function SimpleThreeColumns() {
  return (
    <Box p={4}>
      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10}>
        <Feature
          icon={<Icon as={IoAnalyticsSharp} w={10} h={10} />}
          iconBg={useColorModeValue("yellow.100", "yellow.900")}
          title={"Current Prices"}
          text={
            "Potential real time prices and the ability to pre-budget your groceries"
          }
        />
        <Feature
          icon={<Icon as={IoLogoBitcoin} w={10} h={10} />}
          iconBg={useColorModeValue("green.100", "green.900")}
          title={"Compare"}
          text={
            "Being able to compare prices with different merchants and their products"
          }
        />
        <Feature
          icon={<Icon as={IoSearchSharp} w={10} h={10} />}
          title={"Convenience"}
          iconBg={useColorModeValue("purple.100", "purple.900")}
          text={"Searching and browsing before going to the actual places"}
        />
      </SimpleGrid>
    </Box>
  );
}
